export { VpPageContainer } from './VpPageContainer';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPageContainer/index.js